import { GET_PRODUCTS, LOADING_PRODUCTS } from "../Actions/types";


const initialState = {
    products: [],
    sync_info: null,
    totals: 0,
    loading_products: false,
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case LOADING_PRODUCTS:
        return {
          ...state,
          loading_products: true
        };
      case GET_PRODUCTS:
        return {
          ...state,
          sync_info: action.payload.sync_info,
          products: action.payload.data,
          totals: action.payload.totals,
          loading_products: false
        };
      default:
        return state;
    }
  }
  